import React, { useEffect } from "react";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import logo from "../assets/logo2.png";
import { Image } from "react-bootstrap";

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    const { data: authListener } = supabase.auth.onAuthStateChange(async (event, session) => {
      if (event === "SIGNED_IN") {
        navigate("/dashboard/screens"); // Navigate to dashboard if signed in
      } else {
        navigate("/login"); // Navigate to home if signed out
      }
    });

    // Cleanup subscription on unmount
    return () => {
      if (typeof authListener === 'function') {
        authListener(); // Call the function to unsubscribe
      }
    };
  }, [navigate]); // Add navigate to dependency array

  return (
    <div>
      <div style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '5px', boxShadow: '10px 12px 10px rgba(0,0,0,0.1)', margin: '5% auto', width: '25rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <Image src={logo} alt="logo" width="50" height="100" />
          <h2>Beautcia Admin</h2>
          <h4>Login</h4>
        </div>
        <Auth
          supabaseClient={supabase}
          appearance={{ theme: ThemeSupa }}
          theme="dark"
          providers={[]}
        />
      </div>
    </div>
  )
}
